module.exports = __webpack_public_path__ + "static/media/download.c530d8cc.svg";